import { assetThumbnailUrl } from '@/views/volc-asset/assetMedia'

// Display only: never assign this result to records, versions or references.
export const imageThumbnailUrl = (source, options) => assetThumbnailUrl(source, options)

// Retry only the thumbnail for this source. An original failure stops here,
// and a stale event cannot replace an image belonging to another record.
export function handleImageThumbnailError(event, source, options) {
  const image = event?.target
  const thumbnail = imageThumbnailUrl(source, options)
  if (!source || thumbnail === source || image?.getAttribute('src') !== thumbnail) return false
  image.setAttribute('src', source)
  return true
}
